import { initializeApp, FirebaseApp } from 'firebase/app'
import { getDatabase, Database } from 'firebase/database'

let firebaseApp: FirebaseApp | null = null
let database: Database | null = null

export function initializeFirebase(databaseURL: string) {
    console.log('Initializing Firebase with URL:', `"${databaseURL}"`)
    if (!databaseURL) {
        console.warn('Firebase initialized with empty URL, skipping connection.')
        return null
    }

    // Initialize Firebase with just the database URL
    // No API key needed for open databases
    const config = {
        databaseURL: databaseURL.endsWith('/') ? databaseURL.slice(0, -1) : databaseURL
    }

    try {
        firebaseApp = initializeApp(config, databaseURL) // Use URL as app name for multi-tenancy
        database = getDatabase(firebaseApp)
    } catch (error: any) {
        if (error.code === 'app/duplicate-app') {
            // If app already exists (e.g. re-login), just get the database
            // We can't easily get the existing app instance by name in this version without keeping track
            // But since we are using a module-level variable, we might be fine if we don't re-initialize
            console.log('Firebase app already initialized for this URL')
        } else {
            console.error('Error initializing Firebase:', error)
        }
    }

    return database
}

export function getFirebaseDatabase(): Database | null {
    return database
}

export function disconnectFirebase() {
    if (database) {
        database = null
    }
    if (firebaseApp) {
        firebaseApp = null
    }
}
